import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    SingleTileContainer: () => import("./components/SingleTileContainer.vue"),

    FixedDashboardGrid: () => import("./components/private/FixedDashboardGrid.vue"),
    FixedDashboardCell: () => import("./components/private/FixedDashboardCell.vue"),
    FixedDashboardTopBarTabs: () => import("./components/private/FixedDashboardTopBarTabs.vue"),

    ShortcutEditModal: () => import("./components/tiles/dashboard/shortcuts/shortcutEditModal.vue"),
    ShortcutTile: () => import("./components/tiles/dashboard/shortcuts/shortcutTile.vue"),

    GrapesDashboardContainer: () => import("./components/tiles/dashboard/DashboardContainer.vue"),
    GrapesDashboardIndex: () => import("./components/tiles/dashboard/index.vue"),

    NotificationsIframe: () => import("./components/tiles/dashboard/notifications/NotificationsIframe.vue"),
    NotificationsTileContainer: () => import("./components/tiles/dashboard/notifications/NotificationsTileContainer.vue"),
    NotificationDetailTile: () => import("./components/tiles/dashboard/notifications/notificationDetailTile.vue"),
    PhenologyDetailTile: () => import("./components/tiles/dashboard/phenology/phenologyDetailTile.vue"),

    VineyardSelectionNavBarItem: () => import("./components/navbar/vineyard-select/VineyardSelectionNavBarItem.vue"),
    VineyardBlockSelectionNavBarItem: () => import("./components/navbar/vineyard-block-select/VineyardBlockSelectionNavBarItem.vue"),
    VineyardVarietySelectionNavBarItem: () => import("./components/navbar/vineyard-variety-select/VineyardVarietySelectionNavBarItem.vue"),

};

export default globals;
